module.exports = __webpack_public_path__ + "static/media/icomoon.956f9b2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon.svg?l3qv7r
// module id = 2746
// module chunks = 32